import { Component } from '@angular/core';
import { DemoModeManagerService } from '../demo-mode-manager.service';

@Component({
  selector: 'fini-demo-overlay-chip',
  imports: [],
  templateUrl: './demo-overlay-chip.component.html',
  styleUrl: './demo-overlay-chip.component.scss',
})
export class DemoOverlayChipComponent {
  constructor(private demoService: DemoModeManagerService) {}

  exitDemoMode() {
    this.demoService.disableDemoMode();
  }
}
